import {connect} from "react-redux";
import BAOpportunityList from "./list";
import {bindActionCreators} from "redux";
import {list} from "../../../../service/Opportunities/action";
const mapStateToProps = (state) => ({
    opportunityList:state.Opportunitie.opportunityList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            list
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BAOpportunityList);
